import { PRODUCT_CATALOG as FEATURE_PREFIX } from 'featurePrefix.ids'

const CATALOG_HEADER = 'catalog-page-header'
const CATALOG_GROUP_BY = 'catalog-group-by-dropdown'
const STYLE_CARD = 'style-card-hover'
const CATALOG_PAGE = 'catalog-page'
const PDP = 'product-detail-page'

export const CatalogHeader = {
  CatalogHeading: `${FEATURE_PREFIX}__${CATALOG_HEADER}__heading`,
  ViewOrderButton: `${FEATURE_PREFIX}__${CATALOG_HEADER}__view-order-button`,
} as const

export const CatalogGroupBy = {
  GroupByDropdown: `${FEATURE_PREFIX}__${CATALOG_GROUP_BY}__group-by-dropdown`,
  GroupByLinesheet: `${FEATURE_PREFIX}__${CATALOG_GROUP_BY}__group-by-linesheet-group`,
  GroupBySilhouette: `${FEATURE_PREFIX}__${CATALOG_GROUP_BY}__group-by-silhouette`,
  GroupByBadge: `${FEATURE_PREFIX}__${CATALOG_GROUP_BY}__group-by-badge`,
} as const

export const StyleCardHover = {
  PreviewButton: `${FEATURE_PREFIX}__${STYLE_CARD}__preview-button`,
  ViewAndQuantifyButton: `${FEATURE_PREFIX}__${STYLE_CARD}__view-and-quantify-button`,
  ViewDetailsButton: `${FEATURE_PREFIX}__${STYLE_CARD}__view-details-button`,
} as const

export const CatalogPage = {
  AddToOrderButton: `${FEATURE_PREFIX}__${CATALOG_PAGE}__add-to-order-button`,
  OrderSplittingWarning: `${FEATURE_PREFIX}__${CATALOG_PAGE}__order-splitting-warning`,
} as const

export const ProductDetailPage = {
  ViewAndQuantifyHeader: `${FEATURE_PREFIX}__${PDP}__view-and-quantify-header`,
  ProductDetailsHeader: `${FEATURE_PREFIX}__${PDP}__product-details-header`,
  StyleDetails: `${FEATURE_PREFIX}__${PDP}__style-details-accordion-toggle-button`,
  SizeDetails: `${FEATURE_PREFIX}__${PDP}__size-details-accordion-toggle-button`,
  SizeAddtoOrder: `${FEATURE_PREFIX}__${PDP}__size-add-to-order-button`,
  BackToCatalog: `${FEATURE_PREFIX}__${PDP}__back-button`,
} as const

// QA-facing data-testid values: the E2E selector contract for the catalog and
// the product detail modal (epic sc-263994). Kebab-case, never derived from copy
// or position. Renaming one breaks the Cypress suite.
const CATALOG_FILTERS_TEST_ID = 'catalog-filters'

export const CatalogTestIds = {
  Filters: CATALOG_FILTERS_TEST_ID,
  Search: `${CATALOG_FILTERS_TEST_ID}-search`,
  // Passed to the Toaster, which renders `toast-success-{testId}`
  FiltersAppliedToast: `${CATALOG_FILTERS_TEST_ID}-applied`,
  ColorsAddedToOrderToast: 'catalog-colors-added-to-order',
  ProductCard: (productId: string | number) =>
    `catalog-product-card-${productId}`,
} as const

const SIZED_TABLE_TEST_ID = 'product-detail-sized-table'

export const ProductDetailTestIds = {
  WholesalePrice: 'product-detail-wholesale-price',
  SuggestedRetailPrice: 'product-detail-suggested-retail-price',
  // PanelContainer derives `{testId}-panel-{option.id}`: `product-detail-tabs-panel-sized`
  Tabs: 'product-detail-tabs',
  BulkTab: 'bulk',
  SizedTab: 'sized',
  // Sized table rows carry the color section id. With doors selected the
  // quantity inputs live in one row per door instead of in the color row.
  ColorRow: (sectionId: string) => `${SIZED_TABLE_TEST_ID}-color-${sectionId}`,
  DoorRow: (sectionId: string, doorId: string) =>
    `${SIZED_TABLE_TEST_ID}-door-${sectionId}-${doorId}`,
  PriceRow: (sectionId: string) => `${SIZED_TABLE_TEST_ID}-prices-${sectionId}`,
  UnitsAvailable: (sectionId: string, columnId: string) =>
    `${SIZED_TABLE_TEST_ID}-units-available-${sectionId}-${columnId}`,
} as const
